import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { Alert, Button, Col, Container, FormGroup, Row } from "reactstrap";
import { translationHookOptions } from "../../app/localization/localization";
import { ISpeaker } from "../../app/models/podium";
import classNames from "classnames";
import { RootStoreContext } from "../../app/stores/rootStore";
import { observer } from "mobx-react-lite";
import { getSpeakerIconUrl } from "../../app/helpers/urlHelper";

interface IParams {
  speaker: ISpeaker;
  onPinOK: () => void;
  onCancelClick: () => void;
}

const PodiumSpeakerPinForm: React.FC<IParams> = ({
  speaker,
  onPinOK,
  onCancelClick,
}) => {
  const rootStore = useContext(RootStoreContext);
  const { theme } = rootStore.commonStore;
  const { validatingPin, validateSpeakerPin } = rootStore.podiumStore;
  const [showError, setshowError] = useState(false);
  const [insertedPin, setinsertedPin] = useState("");
  const [t] = useTranslation(["podium", "translation"], translationHookOptions);

  const iconUrl = getSpeakerIconUrl(speaker);

  const checkPin = async () => {
    try {
      let result = await validateSpeakerPin(speaker.id, insertedPin);
      if (result) onPinOK();
      else setshowError(true);
    } catch (error) {
      setshowError(true);
    }
  };

  const handleKeyboardEvent = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter" && !(validatingPin || !insertedPin)) {
      e.preventDefault();
      checkPin();
    }
  };

  return (
    <Container>
      <Row>
        <Col sm={12} lg={{ size: 6, offset: 3 }}>
          <div className="form-wrapper podium-pin-form mt-0">
            <div>
              <img
                className="podium-requirepin-image"
                src={iconUrl}
                alt={speaker.name}
              ></img>
            </div>
            <h5 className="my-4 font-weight-bold">{speaker.name}</h5>
            <h5 className="my-4">{t("insert_doc_pin")}</h5>
            <FormGroup className="form-group input-group-lg">
              <input
                className="form-control mt-2"
                placeholder={t("pin_placeholder")}
                autoComplete="off"
                onChange={(e) => setinsertedPin(e.currentTarget.value)}
                onKeyPress={handleKeyboardEvent}
              ></input>
            </FormGroup>
            {showError && <Alert color="danger">{t("invalid_pin")}</Alert>}
            <Row>
              <Col sm={6}>
                <Button
                  disabled={validatingPin || !insertedPin}
                  className={classNames(
                    "genericButton btn-block mt-2",
                    `${theme!.buttonColor} ${theme!.buttonBorderColor} ${
                      theme!.buttonTextColor
                    }`
                  )}
                  color="dark"
                  type="submit"
                  onClick={checkPin}
                >
                  {t("continue", { ns: "translation" })}
                </Button>
              </Col>
              <Col sm={6}>
                <Button
                  className={classNames(
                    "genericButton btn-block mt-2",
                    `${theme!.buttonColor} ${theme!.buttonBorderColor} ${
                      theme!.buttonTextColor
                    }`
                  )}
                  color="dark"
                  type="submit"
                  onClick={onCancelClick}
                >
                  {t("cancel", { ns: "translation" })}
                </Button>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default observer(PodiumSpeakerPinForm);
